import Downshift from "downshift"
import React from "react"
import "./search-input-filter-mg.scss"

const SearchInputFilterMG = props => {
  return (
    <Downshift
      itemToString={item => (item ? item.tituloArticulo : props.inputValue)}
    >
      {({
        getInputProps,
        getItemProps,
        getMenuProps,
        isOpen,
        inputValue,
        highlightedIndex,
        selectedItem,
        clearSelection,
      }) => (
        <div
          className={
            props.searchActive
              ? "f-input-search-container input-search-active"
              : "f-input-search-container"
          }
        >
          <input
            {...getInputProps({
              placeholder: "Escribe aquí",
              onChange: e => {
                props.setValue(e.target.value)
              },
            })}
            className={
              props.mobile
                ? props.searchActive
                  ? "f-input-search"
                  : "f-input-search padding-mod"
                : "f-input-search"
            }
            onKeyPress={event => {
              if (event.key === "Enter") {
                props.search(inputValue)
                if (event.target.value === "") {
                  clearSelection()
                }
              }
            }}
          />
          <ul {...getMenuProps()}>
            {isOpen
              ? props.contennInfo
                  .filter(
                    item =>
                      (!inputValue && inputValue !== "") ||
                      (item.tituloArticulo
                        .normalize("NFD")
                        .replace(/[\u0300-\u036f]/g, "")
                        .toLowerCase()
                        .trim()
                        .includes(
                          inputValue
                            .normalize("NFD")
                            .replace(/[\u0300-\u036f]/g, "")
                            .toLowerCase()
                            .trim()
                        ) &&
                        inputValue !== "")
                  )
                  .map((item, index) => (
                    <li
                      {...getItemProps({
                        key: index,
                        index,
                        item,
                        style: {
                          backgroundColor:
                            highlightedIndex === index ? "#ffedf6" : "#ececec",
                          fontWeight: selectedItem === item ? "bold" : "normal",
                        },
                      })}
                    >
                      {item.tituloArticulo}
                    </li>
                  ))
              : null}
          </ul>
          {props.mobile ? (
            <>
              <span
                onClick={() => props.setSearch(true)}
                className={
                  props.searchActive
                    ? "f-icon icon-search f-icon-search-input icon-search-active"
                    : "f-icon icon-search f-icon-search-input"
                }
              />
              {props.searchActive && (
                <span
                  className={
                    props.searchActive
                      ? "f-icon icon2-close f-icon-clean-input icon-clean-active"
                      : "f-icon icon2-close f-icon-clean-input"
                  }
                  onClick={() => {
                    props.setCloseSearch()
                    clearSelection()
                  }}
                />
              )}
            </>
          ) : props.inputValue !== "" ? (
            <>
              <span
                onClick={() => props.search(inputValue)}
                className="f-icon icon-search f-icon-search-input"
              />
              <span
                className="f-icon icon2-close f-icon-clean-input"
                onClick={() => {
                  props.setValue("")
                  clearSelection()
                }}
              />
            </>
          ) : (
            <span
              onClick={() => props.search(inputValue)}
              className="f-icon icon-search f-icon-search-input"
            />
          )}
        </div>
      )}
    </Downshift>
  )
}

export default SearchInputFilterMG
